import React, { FC } from 'react'
import hero from '../../assets/img/hero.png'
import verizon from '../../assets/img/verizon.png'
import deliveroo from '../../assets/img/deliveroo.png'
import thalento from '../../assets/img/thalento.png'
import steps from '../../assets/img/steps.jpg'
import meetingPageVideo from '../../assets/img/meetingpagevideo.mp4'
import integration from '../../assets/img/integration.png'
import { Link } from 'react-router-dom'
import { Routes } from '../../routing/routes'

const Hero = () => {

  return (
    <div className="relative bg-gray-50 overflow-hidden">
      <div className="relative pb-16 sm:pb-24 lg:pb-32">
        <main className="mt-16 mx-auto max-w-7xl px-4 sm:mt-24 sm:px-6 lg:mt-32">
          <div className="lg:grid lg:grid-cols-12 lg:gap-8">
            <div className="sm:text-center md:max-w-2xl md:mx-auto lg:col-span-6 lg:text-left">
              <h1>
                <span className="mt-1 block text-4xl tracking-tighter font-extrabold sm:text-5xl xl:text-6xl">
                  <span className="block text-gray-700 m-0">Create your</span>
                  <span className="block text-blue-800 m-0">
                    personalised meeting
                  </span>
                  <span className="block text-gray-700 m-0">page</span>
                </span>
              </h1>
              <p className="mt-6 text-base text-gray-500 sm:mt-5 sm:text-xl lg:text-lg xl:text-xl">
                <b>Schedule meetings</b> with clients, candidates &amp;
                prospects <b>on auto-pilot</b>.
              </p>
              <div className="mt-8 sm:max-w-lg sm:mx-auto sm:text-center lg:text-left lg:mx-0">
                <p className="text-base font-medium text-gray-400">
                  P.S. You can change every aspect of your meeting page
                </p>
                <form action="#" method="POST" className="mt-3 flex flex-col">
                  <input
                    type="text"
                    name="email"
                    id="email"
                    className="block bg-white border border-1 px-3 py-3"
                    placeholder="Enter your email"
                  />
                  <Link
                    to={Routes.ONBOARDING}
                    className="bg-blue-800 text-center text-white rounded rounded-md p-3 font-semibold"
                  >
                    Create my meeting page
                  </Link>
                </form>
                <p className="mt-3 text-sm text-gray-500">
                  We care about the protection of your data. Read our
                  {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                  <a href="#" className="font-medium text-gray-900 underline">
                    Privacy Policy
                  </a>
                  .
                </p>
              </div>
            </div>
            <div className="mt-12 relative sm:max-w-lg sm:mx-auto lg:mt-0 lg:max-w-none lg:mx-0 lg:col-span-6 lg:flex lg:items-center">
              <img src={hero} alt="Hero" />
            </div>
          </div>
        </main>
      </div>
    </div>
  )
}

const LogoCloud = () => {
  return (
    <div className="bg-white">
      <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 gap-8 md:grid-cols-3">
          <div className="col-span-1 flex justify-center md:col-span-2 lg:col-span-1">
            <img className="h-12" src={verizon} alt="verizon" />
          </div>
          <div className="col-span-1 flex justify-center md:col-span-2 lg:col-span-1">
            <img className="h-12" src={deliveroo} alt="deliveroo" />
          </div>
          <div className="col-span-1 flex justify-center md:col-span-3 lg:col-span-1">
            <img className="h-12" src={thalento} alt="thalento" />
          </div>
        </div>
      </div>
    </div>
  )
}

const stepCopy = [
  {
    key: 'Create',
    value: 'Create a meeting page and add your calendars and availability',
  },
  {
    key: 'Share',
    value: 'Share your meeting page with prospects, clients or candidates',
  },
  {
    key: 'Manage',
    value: '(Optional) You accept or refuse the meeting',
  },
  {
    key: 'Sync',
    value: 'The meeting is synced to your calendar, CRM, ATS or other tools',
  },
  {
    key: 'Save time',
    value:
      'You just saved 30 minutes in back-and forth emailing and copy pasting data',
  },
]

const integrations = [
  'Integration with CRM\'s (Salesflare, ...)',
  'Works with your ATS  (Workable, Recruitee, ...)',
  'Zapier Connection',
  'Google, iCloud, Office 365',
  'Facebook Pixel & Google Analytics',
]

const Steps = () => {
  return (
    <div className="flex md:flex-row flex-wrap bg-gray-50">
      <div className="flex-1 hidden md:block p-20 flex flex-col justify-center items-center">
        <img src={steps} className="w-96 m-auto" alt="Steps" />
      </div>
      <div className="flex-1 flex flex-col justify-center py-10 lg:py-20 px-3">
        <h3 className="text-2xl font-extrabold text-gray-600 tracking-tight sm:text-3xl mb-5">
          Get started in a couple of steps
        </h3>
        {stepCopy.map((st) => (
          <div className="flex flex-row my-3" key={st.key}>
            <div className="flex flex-col">
              <span className="text-2xl font-semibold">{st.key}</span>
              <span className="mt-2 text-gray-700">{st.value}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

const BrandingIntegration = () => {
  return (
    <div className="py-16 bg-white overflow-hidden lg:py-24">
      <div className="relative max-w-xl mx-auto px-4 sm:px-6 lg:px-8 lg:max-w-7xl">
        <svg
          className="hidden lg:block absolute left-full transform -translate-x-1/2 -translate-y-1/4"
          width="404"
          height="784"
          fill="none"
          viewBox="0 0 404 784"
          aria-hidden="true"
        >
          <defs>
            <pattern
              id="b1e6e422-73f8-40a6-b5d9-c8586e37e0e7"
              x="0"
              y="0"
              width="20"
              height="20"
              patternUnits="userSpaceOnUse"
            >
              <rect
                x="0"
                y="0"
                width="4"
                height="4"
                className="text-gray-200"
                fill="currentColor"
              />
            </pattern>
          </defs>
          <rect
            width="404"
            height="784"
            fill="url(#b1e6e422-73f8-40a6-b5d9-c8586e37e0e7)"
          />
        </svg>

        <div className="relative mt-12 lg:mt-24 lg:grid lg:grid-cols-2 lg:gap-8 lg:items-center">
          <div className="relative">
            <h3 className="text-2xl font-extrabold text-gray-900 tracking-tight sm:text-3xl">
              Use your brand&apos;s look &amp; feel
            </h3>
            <p className="mt-5 text-lg text-gray-500">
              You can change every detail of your meeting page. From colors and
              logo’s to headings and extra questions you want to ask before
              scheduling a meeting.
            </p>
            <p className="mt-3 text-base text-gray-500">
              Only for geeks: you can add your own CSS and Javascript! (Not
              required)
            </p>
          </div>

          <div className="mt-10 -mx-4 relative lg:mt-0" aria-hidden="true">
            <svg
              className="absolute left-1/2 transform -translate-x-1/2 translate-y-16 lg:hidden"
              width="784"
              height="404"
              fill="none"
              viewBox="0 0 784 404"
            >
              <defs>
                <pattern
                  id="ca9667ae-9f92-4be7-abcb-9e3d727f2941"
                  x="0"
                  y="0"
                  width="20"
                  height="20"
                  patternUnits="userSpaceOnUse"
                >
                  <rect
                    x="0"
                    y="0"
                    width="4"
                    height="4"
                    className="text-gray-200"
                    fill="currentColor"
                  />
                </pattern>
              </defs>
              <rect
                width="784"
                height="404"
                fill="url(#ca9667ae-9f92-4be7-abcb-9e3d727f2941)"
              />
            </svg>
            {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
            <video
              className="relative mx-auto"
              width="490"
              src={meetingPageVideo}
            />
          </div>
        </div>

        <svg
          className="hidden lg:block absolute right-full transform translate-x-1/2 translate-y-12"
          width="404"
          height="784"
          fill="none"
          viewBox="0 0 404 784"
          aria-hidden="true"
        >
          <defs>
            <pattern
              id="64e643ad-2176-4f86-b3d7-f2c5da3b6a6d"
              x="0"
              y="0"
              width="20"
              height="20"
              patternUnits="userSpaceOnUse"
            >
              <rect
                x="0"
                y="0"
                width="4"
                height="4"
                className="text-gray-200"
                fill="currentColor"
              />
            </pattern>
          </defs>
          <rect
            width="404"
            height="784"
            fill="url(#64e643ad-2176-4f86-b3d7-f2c5da3b6a6d)"
          />
        </svg>

        <div className="relative mt-12 sm:mt-16 lg:mt-24">
          <div className="lg:grid lg:grid-flow-row-dense lg:grid-cols-2 lg:gap-8 lg:items-center">
            <div className="lg:col-start-2">
              <h3 className="text-2xl font-extrabold text-gray-900 tracking-tight sm:text-3xl">
                Integrate with your existing tools
              </h3>
              <p className="mt-3 text-lg text-gray-500">
                We believe that a professional meeting scheduling tool should be
                part of your existing workflow.
              </p>

              <dl className="mt-10 space-y-10">
                {integrations.map((integration) => (
                  <div className="flex" key={integration}>
                    <div className="flex-shrink-0">
                      <div className="flex items-center justify-center h-10 w-10 rounded-full bg-green-100 text-green-500">
                        <svg
                          className="w-6 h-6"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M5 13l4 4L19 7"
                          ></path>
                        </svg>
                      </div>
                    </div>
                    <div className="ml-4 flex flex-col justify-center">
                      <dt className="text-lg leading-6 font-medium text-gray-900">
                        {integration}
                      </dt>
                    </div>
                  </div>
                ))}
              </dl>
            </div>

            <div className="mt-10 -mx-4 relative lg:mt-0 lg:col-start-1">
              <svg
                className="absolute left-1/2 transform -translate-x-1/2 translate-y-16 lg:hidden"
                width="784"
                height="404"
                fill="none"
                viewBox="0 0 784 404"
                aria-hidden="true"
              >
                <defs>
                  <pattern
                    id="e80155a9-dfde-425a-b5ea-1f6fadd20131"
                    x="0"
                    y="0"
                    width="20"
                    height="20"
                    patternUnits="userSpaceOnUse"
                  >
                    <rect
                      x="0"
                      y="0"
                      width="4"
                      height="4"
                      className="text-gray-200"
                      fill="currentColor"
                    />
                  </pattern>
                </defs>
                <rect
                  width="784"
                  height="404"
                  fill="url(#e80155a9-dfde-425a-b5ea-1f6fadd20131)"
                />
              </svg>
              <img
                className="relative mx-auto"
                width="490"
                src={integration}
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

const Pricing = () => {
  return (
    <div className="bg-blue-900">
      <div className="pt-12 sm:pt-16 lg:pt-24">
        <div className="max-w-7xl mx-auto text-center px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl mx-auto space-y-2 lg:max-w-none">
            <p className="text-3xl font-extrabold text-white sm:text-4xl lg:text-5xl">
              Pricing
            </p>
          </div>
        </div>
      </div>
      <div className="mt-8 pb-12 bg-gray-50 sm:mt-12 sm:pb-16 lg:mt-16 lg:pb-24">
        <div className="relative">
          <div className="absolute inset-0 h-3/4 bg-blue-900"></div>
          <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="max-w-md mx-auto space-y-4 lg:max-w-5xl lg:grid lg:grid-cols-2 lg:gap-5 lg:space-y-0">
              <div className="flex flex-col rounded-lg shadow-lg overflow-hidden">
                <div className="px-6 py-8 bg-white sm:p-10 sm:pb-6">
                  <div>
                    <h3
                      className="inline-flex px-4 py-1 rounded-full text-sm font-semibold tracking-wide uppercase bg-indigo-100 text-indigo-600"
                      id="tier-standard"
                    >
                      Plus
                    </h3>
                  </div>
                  <div className="mt-4 flex items-baseline text-6xl font-extrabold">
                    1 coffee
                    <span className="ml-1 text-2xl font-medium text-gray-500">
                      /mo
                    </span>
                  </div>
                  <p className="mt-5 text-lg text-gray-500">
                    Per user, per month <b>(€3)</b>
                  </p>
                </div>
                <div className="flex-1 flex flex-col justify-between px-6 pt-6 pb-8 bg-gray-50 space-y-6 sm:p-10 sm:pt-6">
                  <ul className="space-y-4">
                    <li className="flex items-start">
                      <div className="flex-shrink-0">
                        <svg
                          className="h-6 w-6 text-green-500"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                          aria-hidden="true"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M5 13l4 4L19 7"
                          />
                        </svg>
                      </div>
                      <p className="ml-3 text-base text-gray-700">
                        Page customization
                      </p>
                    </li>

                    <li className="flex items-start">
                      <div className="flex-shrink-0">
                        <svg
                          className="h-6 w-6 text-green-500"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                          aria-hidden="true"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M5 13l4 4L19 7"
                          />
                        </svg>
                      </div>
                      <p className="ml-3 text-base text-gray-700">
                        Link multiple people to 1 page
                      </p>
                    </li>

                    <li className="flex items-start">
                      <div className="flex-shrink-0">
                        <svg
                          className="h-6 w-6 text-green-500"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                          aria-hidden="true"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M5 13l4 4L19 7"
                          />
                        </svg>
                      </div>
                      <p className="ml-3 text-base text-gray-700">
                        Integrations (Zapier, Zoom)
                      </p>
                    </li>

                    <li className="flex items-start">
                      <div className="flex-shrink-0">
                        <svg
                          className="h-6 w-6 text-green-500"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                          aria-hidden="true"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M5 13l4 4L19 7"
                          />
                        </svg>
                      </div>
                      <p className="ml-3 text-base text-gray-700">
                        Basic support via chat
                      </p>
                    </li>
                  </ul>
                  <div className="rounded-md shadow">
                    <Link
                      to="/onboarding"
                      className="flex items-center justify-center px-5 py-3 border border-transparent text-base font-medium rounded-md text-white bg-gray-800 hover:bg-gray-900"
                      aria-describedby="tier-standard"
                    >
                      Start free trial
                    </Link>
                  </div>
                </div>
              </div>

              <div className="flex flex-col rounded-lg shadow-lg overflow-hidden">
                <div className="px-6 py-8 bg-white sm:p-10 sm:pb-6">
                  <div>
                    <h3
                      className="inline-flex px-4 py-1 rounded-full text-sm font-semibold tracking-wide uppercase bg-indigo-100 text-indigo-600"
                      id="tier-standard"
                    >
                      Professional
                    </h3>
                  </div>
                  <div className="mt-4 flex items-baseline text-6xl font-extrabold">
                    <span className="text-4xl">€</span>9
                    <span className="ml-1 text-2xl font-medium text-gray-500">
                      /mo
                    </span>
                  </div>
                  <p className="mt-5 text-lg text-gray-500">
                    Per user, per month
                  </p>
                </div>
                <div className="flex-1 flex flex-col justify-between px-6 pt-6 pb-8 bg-gray-50 space-y-6 sm:p-10 sm:pt-6">
                  <ul className="space-y-4">
                    <li className="flex items-start">
                      <div className="flex-shrink-0">
                        <svg
                          className="h-6 w-6 text-green-500"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                          aria-hidden="true"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M5 13l4 4L19 7"
                          />
                        </svg>
                      </div>
                      <p className="ml-3 text-base text-gray-700">
                        All <b>plus</b> features
                      </p>
                    </li>

                    <li className="flex items-start">
                      <div className="flex-shrink-0">
                        <svg
                          className="h-6 w-6 text-green-500"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                          aria-hidden="true"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M5 13l4 4L19 7"
                          />
                        </svg>
                      </div>
                      <p className="ml-3 text-base text-gray-700">
                        Custom integrations
                      </p>
                    </li>

                    <li className="flex items-start">
                      <div className="flex-shrink-0">
                        <svg
                          className="h-6 w-6 text-green-500"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                          aria-hidden="true"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M5 13l4 4L19 7"
                          />
                        </svg>
                      </div>
                      <p className="ml-3 text-base text-gray-700">
                        Team management
                      </p>
                    </li>

                    <li className="flex items-start">
                      <div className="flex-shrink-0">
                        <svg
                          className="h-6 w-6 text-green-500"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                          aria-hidden="true"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M5 13l4 4L19 7"
                          />
                        </svg>
                      </div>
                      <p className="ml-3 text-base text-gray-700">
                        Priority support (phone &amp; chat)
                      </p>
                    </li>
                  </ul>
                  <div className="rounded-md shadow">
                    <Link
                      to="/onboarding"
                      className="flex items-center justify-center px-5 py-3 border border-transparent text-base font-medium rounded-md text-white bg-gray-800 hover:bg-gray-900"
                      aria-describedby="tier-standard"
                    >
                      Start free trial
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-4 relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 lg:mt-5">
          <div className="max-w-md mx-auto lg:max-w-5xl">
            <div className="rounded-lg bg-gray-100 px-6 py-8 sm:p-10 lg:flex lg:items-center">
              <div className="flex-1">
                <div>
                  <h3 className="inline-flex px-4 py-1 rounded-full text-sm font-semibold tracking-wide uppercase bg-white text-gray-800">
                    LIMITED OFFER
                  </h3>
                </div>
                <div className="mt-4 text-lg text-gray-600">
                  Get a lifetime <b>plus</b> license. Now for only{' '}
                  <span className="font-semibold text-gray-900">€69</span>.
                </div>
              </div>
              <div className="mt-6 rounded-md shadow lg:mt-0 lg:ml-10 lg:flex-shrink-0">
                <Link
                  to="/onboarding"
                  className="flex items-center justify-center px-5 py-3 border border-transparent text-base font-medium rounded-md text-gray-900 bg-white hover:bg-gray-50"
                >
                  Get a lifetime license
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export const LandingPage: FC = () => {
  return (
    <div className="serif anti-aliased">
      <Hero />
      <LogoCloud />
      <Steps />
      <BrandingIntegration />
      <Pricing />
    </div>
  )
}
